import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

import DialogFavorites from 'components/DialogFavorites';
import DialogMakePayment from 'components/DialogMakePayment';
import DialogSecureNotes from 'components/DialogSecureNotes';
import DrawerEditUser from 'components/DrawerEditUser';
import ReferAFriendDialog from 'components/ReferAFriendDialog';
import { useUsername } from 'modules/oidc/useAuthenticated';
import navDialogsContext from './navDialogsContext';

const NavDialogsProvider = ({ children }: { children: React.ReactNode }) => {
	const location = useLocation();
	const searchParams = new URLSearchParams(location.search);
	const viewSecureNotes = searchParams.get('viewSecureNotes');

	const [isMakePaymentOpen, setIsMakePaymentOpen] = useState(false);
	const [isSecureNotesOpen, setIsSecureNotesOpen] = useState(false);
	const [isReferFriendModalOpen, setIsReferFriendModalOpen] = useState(false);
	const [isFavoritesOpen, setIsFavoritesOpen] = useState(false);
	const [isEditUserOpen, setIsEditUserOpen] = useState(false);

	const username = useUsername();

	useEffect(() => {
		if (viewSecureNotes === 'true') {
			setIsSecureNotesOpen(true);
		}
	}, [viewSecureNotes]);

	const value = useMemo(
		() => ({
			isEditUserOpen,
			isFavoritesOpen,
			isMakePaymentOpen,
			isReferFriendModalOpen,
			isSecureNotesOpen,
			setIsEditUserOpen,
			setIsFavoritesOpen,
			setIsMakePaymentOpen,
			setIsReferFriendModalOpen,
			setIsSecureNotesOpen,
		}),
		[
			isEditUserOpen,
			isFavoritesOpen,
			isMakePaymentOpen,
			isReferFriendModalOpen,
			isSecureNotesOpen,
			setIsEditUserOpen,
			setIsFavoritesOpen,
			setIsMakePaymentOpen,
			setIsReferFriendModalOpen,
			setIsSecureNotesOpen,
		],
	);
	return (
		<navDialogsContext.Provider value={value}>
			{children}

			<DialogMakePayment
				onClose={() => setIsMakePaymentOpen(false)}
				open={isMakePaymentOpen}
			/>
			<DialogSecureNotes
				onClose={() => setIsSecureNotesOpen(false)}
				open={isSecureNotesOpen}
			/>
			<ReferAFriendDialog
				onClose={() => setIsReferFriendModalOpen(false)}
				open={isReferFriendModalOpen}
			/>
			<DialogFavorites
				onClose={() => setIsFavoritesOpen(false)}
				open={isFavoritesOpen}
			/>

			<DrawerEditUser
				onClose={() => setIsEditUserOpen(false)}
				open={isEditUserOpen}
				username={username || ''}
				focusPassphrase
			/>
		</navDialogsContext.Provider>
	);
};

export default NavDialogsProvider;
